/**
** 组织机构： 机构列表
 */
<template>
  <div id="organlist" class="jc-page">
    <div class="jc-panel jc-page-head">
      <div class="header-title">{{ headerTitle }}</div>
      <div class="header-operation">
        <el-form ref="form" :model="form">
          <el-form-item>
            <el-select clearable v-model="form.organType" placeholder="机构类型" @change="handleChange()">
              <el-option v-for="item in organOptions" :key="item.organization_type_id"
                :label="item.organization_type_name" :value="item.organization_type_id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <!-- <el-input v-model="form.parentOrgan" placeholder="请搜索父级机构"></el-input> -->
            <el-cascader clearable ref="cascaparentOrgan" placeholder="请搜索父级机构" v-model="form.parentOrgan"
              :options="parentOrganOptions" :props="{ value: 'organization_name', label: 'organization_name' }"
              :show-all-levels="false">
            </el-cascader>
          </el-form-item>
          <el-form-item>
            <el-input v-model="form.organName" placeholder="请搜索机构名称"></el-input>
          </el-form-item>
          <!-- <el-form-item> -->
          <el-button id="query" class="button" @click="getOrganList">查询</el-button>
          <!-- </el-form-item>
                    <el-form-item> -->
          <el-button class="button" @click="handleDeletMulit">删除</el-button>
          <!-- </el-form-item>
                    <el-form-item> -->
          <el-button class="button" @click="add">添加</el-button>
          <!-- </el-form-item> -->
        </el-form>
      </div>
    </div>
    <div class="jc-table-container jc-scroll-panel">
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" label="序号" width="55"></el-table-column>
        <el-table-column label="机构名称" width="200">
          <template slot-scope="scope">{{ scope.row.organization_name }}</template>
        </el-table-column>
        <el-table-column label="机构类型" width="200" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.organization_type_name }}</template>
        </el-table-column>
        <el-table-column label="父级机构" width="200">
          <template slot-scope="scope">{{ scope.row.organization_parent_name }}</template>
        </el-table-column>
        <el-table-column label="归属地" width="120">
          <template slot-scope="scope">{{ scope.row.organization_region_name }}</template>
        </el-table-column>
        <el-table-column label="机构地址" width="250">
          <template slot-scope="scope">{{ scope.row.organization_address }}</template>
        </el-table-column>
        <el-table-column label="联系电话">
          <template slot-scope="scope">{{ scope.row.charge_mobile }}</template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
            <span>|</span>
            <el-button type="text" size="small" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background style="text-align:right" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="count"
        layout="total, prev, pager, next" :total="total">
      </el-pagination>
    </div>

    <el-dialog title="机构添加" :visible.sync="dialogVisible" class="dialog">
      <el-form ref="addOrganForm" :rules="addRules" :model="addOrganForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="机构名称">
              <el-input v-model="addOrganForm.name" placeholder="请输入机构名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="机构类型">
              <el-select clearable v-model="addOrganForm.type" placeholder="请选择机构类型"
                @change="handleAddDialogTypeChange()">
                <el-option v-for="item in organOptions" :key="item.organization_type_id"
                  :label="item.organization_type_name" :value="item.organization_type_id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="父级机构">
              <!-- <el-select v-model="addOrganForm.parentOrgan" placeholder="请选择父级机构">
                                <el-option 
                                    v-for="item in parentOrganOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select> -->
              <el-cascader :disabled="addDialogCheckDisabled" clearable style="display:block;" ref="cascaparentOrgan"
                placeholder="请选择父级机构" v-model="addOrganForm.parentOrgan" :options="parentOrganOptions"
                :props="{ value: 'organization_id', label: 'organization_name', checkStrictly: true }">
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="考察层级">
              <el-select clearable :disabled="addDialogCheckDisabled" v-model="addOrganForm.level" placeholder="请选择考察层级">
                <el-option v-for="item in levelOptions" :key="item.investigation_level_id"
                  :label="item.investigation_level_name" :value="item.investigation_level_id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="归属地">
              <!-- <el-select v-model="addOrganForm.attribution" placeholder="请选择归属地">
                                <el-option 
                                    v-for="item in attrOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select> -->
              <el-cascader clearable style="display:block;" ref="cascaAttribution" placeholder="请选择归属地"
                v-model="addOrganForm.attribution" :options="attrOptions" @change="selectItem"
                :props="{ value: 'region_id', label: 'region_name', checkStrictly: true }">
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="机构管理员账户名">
              <el-input v-model="addOrganForm.account" placeholder="请输入账号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="addOrganForm.level == '12'">
          <el-col :span="24">
            <div id="MapBox" style="display: flex;flex-direction: column;align-items: flex-start;">
              <span style="font-size: 16px;margin-bottom: 14px;">地理位置拾取</span>
              <div style="display: inline;    flex-direction: row;    align-items: flex-end;">
                <div id="container">
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="机构管理员密码" prop="password">
              <el-input v-model="addOrganForm.password" placeholder="请输入密码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="确认密码" prop="conPassword">
              <el-input v-model="addOrganForm.conPassword" placeholder="请再次输入密码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系电话">
              <el-input v-model="addOrganForm.telephone" placeholder="请输入机构电话"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="机构地址">
              <el-input v-model="addOrganForm.address" placeholder="请输入机构地址"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="addSubmit">确定</el-button>
      </div>
    </el-dialog>


    <!--机构详情dailog-->
    <el-dialog title="机构详情" :visible.sync="detailDialogVisible" class="dialog">
      <el-form ref="detailOrganForm" :model="detailOrganForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="机构名称">
              <el-input v-model="detailOrganForm.name" placeholder="请输入机构名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="机构类型">
              <el-select clearable v-model="detailOrganForm.type" placeholder="请选择机构类型"
                @change="handleModifyDialogTypeChange()">
                <el-option v-for="item in organOptions" :key="item.organization_type_id"
                  :label="item.organization_type_name" :value="item.organization_type_id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="父级机构">
              <!-- <el-select v-model="addOrganForm.parentOrgan" placeholder="请选择父级机构">
                                <el-option 
                                    v-for="item in parentOrganOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select> -->
              <el-cascader clearable style="display:block;" ref="cascaparentOrgan" placeholder="请选择父级机构"
                v-model="detailOrganForm.parentOrgan" :options="parentOrganOptions"
                :props="{ value: 'organization_id', label: 'organization_name', checkStrictly: true }">
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="考察层级">
              <el-select clearable :disabled="modifyDialogCheckDisabled" v-model="detailOrganForm.level"
                placeholder="请选择考察层级">
                <el-option v-for="item in levelOptions" :key="item.investigation_level_id"
                  :label="item.investigation_level_name" :value="item.investigation_level_id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="归属地">
              <!-- <el-select v-model="addOrganForm.attribution" placeholder="请选择归属地">
                                <el-option 
                                    v-for="item in attrOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select> -->
              <el-cascader clearable style="display:block;" ref="cascaAttribution" placeholder="请选择归属地"
                v-model="detailOrganForm.attribution" :options="attrOptions" @change="selectItem"
                :props="{ value: 'region_id', label: 'region_name', checkStrictly: true }" :show-all-levels="false">
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="机构管理员账户名">
              <el-input v-model="detailOrganForm.account" placeholder="请输入账号"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
                       <el-form-item label="机构管理员密码">
                            <el-input v-model="detailOrganForm.password" placeholder="请输入密码"></el-input>
                        </el-form-item>
                   </el-col> -->
        </el-row>
        <el-row v-show="detailOrganForm.level == 12">
          <el-col :span="24">
            <div id="MapBox" style="display: flex;flex-direction: column;align-items: flex-start;">
              <span style="font-size: 16px;margin-bottom: 14px;">地理位置拾取</span>
              <div style="display: inline;    flex-direction: row;    align-items: flex-end;">
                <div id="container1">
                </div>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="机构管理员密码" prop="password">
              <el-input v-model="detailOrganForm.password" placeholder="请输入密码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="确认密码" prop="conPassword">
              <el-input v-model="detailOrganForm.conPassword" placeholder="请再次输入密码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系电话">
              <el-input v-model="detailOrganForm.telephone" placeholder="请输入机构电话"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="机构地址">
              <el-input v-model="detailOrganForm.address" placeholder="请输入机构地址"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
                   <el-col :span="12">
                       <el-form-item label="联系电话">
                            <el-input v-model="detailOrganForm.telephone" placeholder="请输入机构电话"></el-input>
                        </el-form-item>
                   </el-col>
               </el-row>    -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="addDetailInfo">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import { organ, getLevelNameById } from "../../../../utils/organ"
import AMapLoader from "@amap/amap-jsapi-loader";
import { getInvestigationLevelList, deleteOrganizationInfo, getOrganizationDetail, saveOrganizationInfo, saveOrgInfo, getOrganizationTypeList, getOrganizationTreeListByType, getRegionTreeList, getOrganizationList, getPosition } from '@/apis/organlist'
export default {
  name: "Organlist",
  data() {
    return {
      position: [],
      addRules: {
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        conPassword: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      modifyDialogCheckDisabled: true,
      addDialogCheckDisabled: true,
      headerTitle: "机构列表",
      multipleSelection: [],//表格
      dialogVisible: false,//对话框显示标识
      detailDialogVisible: false,// 机构详情对话框显示标识
      form: {
        parentOrgan: "",
        organType: "",
        organName: "",
      },
      organOptions: [
      ], // 机构类型
      parentOrganOptions: [
      ], // 父级机构
      attrOptions: [
      ], // 归属地
      levelOptions: [

      ],// 考察层级
      tableData: [
        // {
        //     organization_id: "",
        //     organization_name:"",
        //     organization_type_name:"",
        //     organization_parent_name:"",
        //     organization_region_name:"",
        //     organization_address:"",
        //     charge_realname:"",
        //     charge_mobile:"" 
        // }
      ],//表格内容
      addOrganForm: {
        name: "",
        type: "",
        parentOrgan: "",
        attribution: "",
        account: "",
        password: "",
        conPassword: "",
        address: "",
        telephone: "",
        level: "",
      },//机构添加的表单内容
      detailOrganForm: {
        name: "",
        type: "",
        parentOrgan: "",
        attribution: "",
        account: "",
        password: "",
        conPassword: "",
        address: "",
        telephone: "",
        level: "",
      },// 机构详情的表单内容
      currentPage: 1,// 当前页数
      count: 10,//表格页数
      total: 0,// 总条目数
      detail: null,// 表格当前行机构详情
      district: null,
      polygon: null,
      polygons: null,
      map: null,
      map1: null,
      marker: null,
      temp_region_id: "",
    }
  },
  mounted() {
    this.loadData()
  },
  created() {
    // this.getOrganTypeList();
  },
  methods: {
    selectItem(value) {
      if (value.length == 3) {
        this.getProvince(JSON.parse(JSON.stringify(value))[2]);
      }
    },
    add() {
      this.dialogVisible = true
      this.getRegionList()
      this.initMap("container")
    },
    loadData() {
      //7-基础-获取机构类型
      this.getOrganTypeList();
      // 09-基础-获得地区层级列表
      this.getRegionList();
      this.getOrganList()
      this.getParentOrganList()
    },
    async initMap(containerId) {
      AMapLoader.load({
        key: "6bbe90d8254c3cc452e1346bf9957d2e", // 开发者Key
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ['AMap.DistrictSearch', 'AMap.Polygon'], // 需要使用的的插件列表
      })
        .then((AMap) => {
          this.map = new AMap.Map(containerId, {
            //设置地图容器id
            viewMode: "2D", //地图模式
            zoom: 12, //初始化地图级别
            center: [116.754649, 39.819499], //初始化地图中心点位置
          });
          this.map.on('click', (e) => {
            this.position.pop();
            this.position.pop();
            this.position.push(e.lnglat.getLng());
            this.position.push(e.lnglat.getLat());
            this.drawMarker(this.position);
            this.$message({
              message: '坐标定位已保存',
              type: 'success'
            });
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },

    drawMarker(location) {
      if (location == null) return
      let longitude = location[0], latitude = location[1]
      if (this.marker) {
        this.marker.setMap(null);
      }
      this.marker = new AMap.Marker({
        position: new AMap.LngLat(longitude, latitude),
        anchor: 'bottom-center',
      });
      this.map.add(this.marker);
    },

    async getProvince(adcode) {
      await getPosition({ id: adcode }).then(res => {
        this.map.setCenter([res.longitude, res.latitude]);
      })

    },

    handleSelectionChange(val) {
      this.multipleSelection = [];
      //organization_id
      val.forEach(item => {
        this.multipleSelection.push(parseInt(item.organization_id));
      })
    },
    handleSizeChange(val) {
    },
    handleCurrentChange(val) {
      this.getOrganList()
    },
    // 表格中点击"删除"
    // 06-机构-删除机构信息
    handleDelete(index, row) {
      this.$confirm('是否确定删除数据？', "提示").then(() => {
        deleteOrganizationInfo({ organization_id_list: [row.organization_id] }).then(res => {
          if (res.data.status == "1") {
            this.$message({
              message: '删除成功！',
              type: 'success'
            });
            this.loadData()
          } else {
            this.$message.error('删除失败！');
          }
        })
      })

    },
    // 点击头部“删除”按钮-批量删除
    handleDeletMulit() {
      this.$confirm('是否确定删除数据？', "提示").then(() => {
        let obj = {
          organization_id_list: this.multipleSelection
        }
        deleteOrganizationInfo(obj).then(res => {
          console.log('删除', res);
          if (res.data.status == "1") {
            this.$message({
              message: '删除成功！',
              type: 'success'
            });
            this.loadData()
          } else {
            this.$message.error(`${res.data.msg}`);
          }
        })
      })

    },
    // 点击表格中"编辑"-列表详情框显示
    // 04-机构-获取机构详情
    getOrganizationParentIds(parentId) {
      let ids = []
      for (let i = 0; i < this.parentOrganOptions.length; i++) {
        if (this._getOrganizationParentIds(this.parentOrganOptions[i], parentId, ids)) {
          ids.unshift(this.parentOrganOptions[i].organization_id)
          break
        }
      }
      return ids
    },
    _getOrganizationParentIds(data, parentId, ids) {
      if (data.organization_id == parentId) {
        return true
      } else {
        for (let i = 0; data.children && i < data.children.length; i++) {
          if (this._getOrganizationParentIds(data.children[i], parentId, ids)) {
            ids.unshift(data.children[i].organization_id)
            return true
          }
        }
      }
      return false
    },
    getRegionParentIds(parentId) {
      let ids = []
      for (let i = 0; i < this.attrOptions.length; i++) {
        if (this._getRegionParentIds(this.attrOptions[i], parentId, ids)) {
          ids.unshift(this.attrOptions[i].region_id)
          break
        }
      }
      return ids
    },
    _getRegionParentIds(data, parentId, ids) {
      if (data.region_id == parentId) {
        return true
      } else {
        for (let i = 0; data.children && i < data.children.length; i++) {
          if (this._getRegionParentIds(data.children[i], parentId, ids)) {
            ids.unshift(data.children[i].region_id)
            return true
          }
        }
      }
      return false
    },
    handleEdit(index, row) {
      this.detail = row;
      this.detailDialogVisible = true;
      getOrganizationDetail({ organization_id: row.organization_id }).then(async res => {
        let data = res.data.data.organization_info;
        let organization_id = data.organization_parent_info.organization_parent_id;
        let region_id = data.organization_region_info.organization_region_id;
        let attributionId = region_id.substring(0, 6);
        this.temp_region_id = region_id;

        this.detailOrganForm.organization_id = data.organization_id;
        this.detailOrganForm.name = data.organization_name;
        this.detailOrganForm.type = data.organization_type_info.organization_type_id;
        this.modifyDialogCheckDisabled = this.detailOrganForm.type.length > 0 ? false : true
        this.detailOrganForm.account = data.organization_surper_username;
        this.detailOrganForm.address = data.organization_address;
        this.detailOrganForm.telephone = data.charge_mobile;
        this.detailOrganForm.level = data.investigation_level_info.investigation_level_id
        this.modifyDialogCheckDisabled = this.detailOrganForm.type.length > 0 ? false : true
        let obj = {
          organization_type_id: this.detailOrganForm.type
        }
        console.log(this.detailOrganForm.level)
        this.initMap("container1")
        getOrganizationTreeListByType(obj).then(res => {
          this.parentOrganOptions = res.data.data.organization_by_type_list;
          this.detailOrganForm.parentOrgan = this.getOrganizationParentIds(organization_id);
        })
        getRegionTreeList().then(res => {
          this.attrOptions = res.data.data.region_tree_list;
          this.detailOrganForm.attribution = this.getRegionParentIds(attributionId);
        })
        if (data.investigation_level_info.investigation_level_id == 12) {
          await getPosition({ id: region_id }).then(res => {
            var temPosition = [parseFloat(res.longitude), parseFloat(res.latitude)]
            console.log(res)
            this.drawMarker(temPosition);
            console.log(temPosition)
            this.map.setCenter(temPosition);
            
          })
        }
        this.getCkeckLevellist(obj);
      })
    },
    // 点击机构详情dialog对话框中“确定”按钮
    async addDetailInfo() {
      if (this.detailOrganForm.password != this.detailOrganForm.conPassword) {
        this.$message({
          message: '密码不一致',
          type: 'error'
        });
        return
      }
      if (this.detailOrganForm.level == '12') {
        var temp_organization_parent_id = "";
        var temp_organization_region_id = "";
        if (this.temp_region_id.substring(0, 6) == this.detailOrganForm.parentOrgan[this.detailOrganForm.parentOrgan.length - 1]) {
          temp_organization_parent_id = this.temp_organization_region_id.substring(0, 6);
          temp_organization_region_id = this.temp_organization_region_id;
        } else {
          temp_organization_parent_id = this.detailOrganForm.parentOrgan.length == 0 ? '0' : this.detailOrganForm.parentOrgan[this.detailOrganForm.parentOrgan.length - 1];
          temp_organization_region_id = this.detailOrganForm.attribution.length == 0 ? '0' : this.detailOrganForm.attribution[this.detailOrganForm.attribution.length - 1] * 1000 + Math.floor(Math.random() * 900 + 100);
        }
        let obj = {
          organization_id: this.detailOrganForm.organization_id,
          organization_name: this.detailOrganForm.name,
          organization_address: this.detailOrganForm.address,
          organization_surper_username: this.detailOrganForm.account,
          organization_surper_password: this.detailOrganForm.password,
          charge_mobile: this.detailOrganForm.telephone,
          organization_type_id: this.detailOrganForm.type,
          organization_parent_id: temp_organization_parent_id,
          organization_region_id: temp_organization_region_id,

          investigation_level_id: this.detailOrganForm.level,
          organization_position: JSON.parse(JSON.stringify(this.position)),
        }
        saveOrganizationInfo(obj).then(async res => {
          if (res.data.status == "1") {
            await saveOrgInfo({ id: obj.organization_region_id, cityname: obj.organization_name, parentid: obj.organization_parent_id, depth: 4, longitude: obj.organization_position[0], latitude: obj.organization_position[1] }).then(res => {
              if (res == 1) {
                this.detailDialogVisible = false;
                this.$message({
                  message: '添加成功！',
                  type: 'success'
                });
                this.loadData()
              } else {
                this.$message.error("添加失败");
              }
            })
          } else {
            this.$message.error(`${res.data.msg}`);
          }
        })
      } else {
        let obj = {
          organization_id: this.detailOrganForm.organization_id,
          organization_name: this.detailOrganForm.name,
          organization_address: this.detailOrganForm.address,
          organization_surper_username: this.detailOrganForm.account,
          organization_surper_password: this.addOrganForm.password,
          charge_mobile: this.detailOrganForm.telephone,
          organization_type_id: this.detailOrganForm.type,
          organization_parent_id: this.detailOrganForm.parentOrgan.length == 0 ? '0' : this.detailOrganForm.parentOrgan[this.detailOrganForm.parentOrgan.length - 1],
          organization_region_id: this.detailOrganForm.attribution.length == 0 ? '0' : this.detailOrganForm.attribution[this.detailOrganForm.attribution.length - 1],
          investigation_level_id: this.detailOrganForm.level
        }
        saveOrganizationInfo(obj).then(res => {
          if (res.data.status == "1") {
            this.detailDialogVisible = false;
            this.$message({
              message: '添加成功！',
              type: 'success'
            });
            this.loadData()
          } else {
            this.$message.error(`${res.data.msg}`);
          }
        })
      }
    },
    // 7-基础-获取机构类型
    getOrganTypeList() {
      // 构造参数
      // let area_id = "";
      getOrganizationTypeList().then(res => {
        this.organOptions = res.data.data.organization_type_list;
      })
    },
    // 当机构类型改变时，获取当前机构类型所对应的父级机构
    // 08-机构-根据机构类型获得机构层级关系树
    handleChange() {
      let obj = {
        organization_type_id: this.form.organType
      }

    },
    handleAddDialogTypeChange() {
      //detailOrganForm.type
      this.addDialogCheckDisabled = this.addOrganForm.type.length > 0 ? false : true
      let obj = {
        organization_type_id: this.addOrganForm.type
      }

      getOrganizationTreeListByType(obj).then(res => {
        this.parentOrganOptions = res.data.data.organization_by_type_list;
      })
      this.getCkeckLevellist(obj);
    },
    handleModifyDialogTypeChange() {
      //detailOrganForm.type
      this.modifyDialogCheckDisabled = this.detailOrganForm.type.length > 0 ? false : true
      let obj = {
        organization_type_id: this.detailOrganForm.type
      }

      getOrganizationTreeListByType(obj).then(res => {
        this.parentOrganOptions = res.data.data.organization_by_type_list;
      })
      this.getCkeckLevellist(obj);
    },
    // 父级机构-获取级联选择的label值
    handleCascaChange() {
      let arr = this.$refs['cascaparentOrgan'].getCheckedNodes()[0].pathLabels;
      this.form.parentOrgan = arr.slice(-1)[0];

    },
    // 归属地-获取归属地最后一级的id
    handleAttriChange() { },
    // 点击“查询”按钮获取机构列表：03-机构-获取机构列表
    getOrganList() {
      /*
      if(this.form.parentOrgan=== "" || this.form.organType==="" || this.form.organName===""){
           this.$message.error('查询条件不用为空');
           //return;
      }
      */
      let obj = {
        // organization_parent_name:this.form.parentOrgan,
        // organization_type_id:this.form.organType,
        // organization_name:this.form.organName,
        organization_type_id: this.form.organType,
        organization_name: this.form.organName,
        organization_parent_name: this.form.parentOrgan.length > 0 ? this.form.parentOrgan[0] : '',
        pagination: {
          page: this.currentPage,
          count: this.count
        }
      }
      getOrganizationList(obj).then(res => {
        if (res.data.status == '1') {
          this.$message({
            message: '查询成功！',
            type: 'success'
          });
          this.tableData = res.data.data.organization_list;
          console.log(this.tableData);
          this.total = parseInt(res.data.data.paginated.total)
        } else {
          this.$message.error(`${res.data.msg}`);
        }
      })
    },
    getParentOrganList() {
      /*
      if(this.form.parentOrgan=== "" || this.form.organType==="" || this.form.organName===""){
           this.$message.error('查询条件不用为空');
           //return;
      }
      */
      let obj = {
        // organization_parent_name:this.form.parentOrgan,
        // organization_type_id:this.form.organType,
        // organization_name:this.form.organName,
        organization_type_id: this.form.parentOrgan,
        organization_name: this.form.organType,
        organization_parent_name: this.form.organName,
        pagination: {
          page: this.currentPage,
          count: this.count
        }
      }
      getOrganizationList(obj).then(res => {
        if (res.data.status == '1') {
          this.$message({
            message: '查询成功！',
            type: 'success'
          });
          this.parentOrganOptions = res.data.data.organization_list;
        } else {
          this.$message.error(`${res.data.msg}`);
        }
      })
    },
    // 点击添加机构列表dialog的“确定”按钮
    // 05-机构-保存机构信息
    addSubmit() {
      this.$refs.addOrganForm.validate(valid => {
        if (valid) {
          if (this.addOrganForm.password != this.addOrganForm.conPassword) {
            this.$message({
              message: '密码不一致',
              type: 'error'
            });
            return
          }
          if (this.addOrganForm.level == 12) {
            let obj = {
              organization_id: "0",
              organization_name: this.addOrganForm.name,
              organization_address: this.addOrganForm.address,
              organization_surper_username: this.addOrganForm.account,
              organization_surper_password: this.addOrganForm.password,
              charge_mobile: this.addOrganForm.telephone,
              organization_type_id: this.addOrganForm.type,
              organization_parent_id: this.addOrganForm.parentOrgan.length == 0 ? '0' : this.addOrganForm.parentOrgan[this.addOrganForm.parentOrgan.length - 1],
              organization_region_id: this.addOrganForm.attribution.length == 0 ? '0' : this.addOrganForm.attribution[this.addOrganForm.attribution.length - 1] * 1000 + Math.floor(Math.random() * 900 + 100),
              investigation_level_id: this.addOrganForm.level,
              organization_position: JSON.parse(JSON.stringify(this.position))
            };
            //Parentid问题
            saveOrganizationInfo(obj).then(async res => {
              if (res.data.status == '1') {
                this.dialogVisible = false;
                await saveOrgInfo({ id: obj.organization_region_id, cityname: obj.organization_name, parentid: obj.organization_parent_id, depth: 4, longitude: obj.organization_position[0], latitude: obj.organization_position[1] }).then(res => {
                  if (res == 1) {
                    this.detailDialogVisible = false;
                    this.$message({
                      message: '添加成功！',
                      type: 'success'
                    });
                    this.loadData()
                  } else {
                    this.$message.error("添加失败");
                  }
                })
                this.$message({
                  message: '添加成功！',
                  type: 'success'
                });
                this.loadData()
                this.addOrganForm = {
                  name: "",
                  type: "",
                  parentOrgan: "",
                  attribution: "",
                  account: "",
                  password: "",
                  conPassword: "",
                  address: "",
                  telephone: "",
                  level: "",
                }
              } else {
                this.$message.error(`${res.data.msg}`);
              }
            })

          } else {
            let obj = {
              organization_id: "0",
              organization_name: this.addOrganForm.name,
              organization_address: this.addOrganForm.address,
              organization_surper_username: this.addOrganForm.account,
              organization_surper_password: this.addOrganForm.password,
              charge_mobile: this.addOrganForm.telephone,
              organization_type_id: this.addOrganForm.type,
              organization_parent_id: this.addOrganForm.parentOrgan.length == 0 ? '0' : this.addOrganForm.parentOrgan[this.addOrganForm.parentOrgan.length - 1],
              organization_region_id: this.addOrganForm.attribution.length == 0 ? '0' : this.addOrganForm.attribution[this.addOrganForm.attribution.length - 1],
              investigation_level_id: this.addOrganForm.level,
              organization_position: JSON.parse(JSON.stringify(this.position))
            };
            saveOrganizationInfo(obj).then(res => {
              if (res.data.status == '1') {
                this.dialogVisible = false;
                this.$message({
                  message: '添加成功！',
                  type: 'success'
                });
                this.loadData()
                this.addOrganForm = {
                  name: "",
                  type: "",
                  parentOrgan: "",
                  attribution: "",
                  account: "",
                  password: "",
                  conPassword: "",
                  address: "",
                  telephone: "",
                  level: "",
                }
              } else {
                this.$message.error(`${res.data.msg}`);
              }
            })
          }
        } else {
          return false
        }
      })

    },
    // 09-基础-获得地区层级列表(联动获取05-保存机构信息-机构归属地id)
    getRegionList() {
      getRegionTreeList().then(res => {
        this.attrOptions = res.data.data.region_tree_list;
      })
    },
    // 34-基础-获得考察层级列表
    getCkeckLevellist(param) {
      getInvestigationLevelList(param).then(res => {
        this.levelOptions = res.data.data.investigation_level_list
      })
    }

  }
}
</script>
<style scoped>
#organlist {
  position: relative;
}

.header {
  width: 100%;
  height: 35px !important;
  border-bottom: 1px solid #ccc;
}

.header-left {
  width: 200px;
  text-align: left;
  position: absolute;
}

.header-title {
  font-weight: bold;
}

.header-right {
  position: absolute;
  right: 20px;
  /* width: 55%; */
  height: 35px;
  top: -15px;
}

.el-form {
  display: flex;
  height: 35px;
}

.el-form-item {
  width: 180px;
  margin-right: 10px;
}

.button {
  height: 38px;
  color: #fff;
  background-color: #000;
}

#organlist>>>.el-input__inner {
  height: 35px;
  padding: 0 10px;
  border: 1px solid #000;
}

#organlist>>>.el-input input::-webkit-input-placeholder {
  color: #9e9fa3;
}

/* 表格样式修改 */
.el-table {
  color: #000;
}

#organlist>>>.el-table thead {
  color: #000;
  font-weight: unset;
}

#organlist>>>.el-table__header {
  width: 100%;

}

#organlist>>>.el-table th.el-table__cell {
  background-color: #f3f3f3;
}

/* #organlist >>> .el-table tr{
    
} */
#organlist>>>.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: unset;
}

.el-button--text {
  color: #000;
  font-size: 13px;
}

.el-table__row>td {
  border: none;
}

.el-table::before {
  height: 0px;
}

#organlist>>>.el-checkbox__inner {
  width: 16px;
  height: 16px;
  border: 1px solid #9e9fa3;
}

/* 对话框样式修改 */
#organlist>>>.dialog .el-dialog__header {
  text-align: left;
}

#organlist>>>.dialog .el-dialog__title {
  font-size: 20px;
}

#organlist>>>.dialog .el-dialog__body {
  padding: 10px 20px;
  color: #000;
}

#organlist>>>.dialog .el-dialog__body .el-form {
  width: 100%;
  height: 100%;
  display: block;
}

#organlist>>>.dialog .el-dialog__body .el-form-item {
  width: 85%;
  margin-bottom: 15px;
}

#organlist>>>.dialog .el-form-item__label {
  color: #000;
  font-size: 16px;
  text-align: left;
  line-height: 35px;
}

#organlist>>>.dialog .el-input__inner {
  border: 1px solid #409eff;
  color: #000;
}

#organlist>>>.dialog .el-select {
  width: 100%;
}

#organlist>>>.dialog .el-dialog__footer {
  padding: 0px 20px 20px;
}

#container {
  width: 700px;
  height: 400px;
}

#container1 {
  width: 700px;
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/backStage/children/Organlist/Organlist.vue